import { GET_PRE_SIGNED_UPLOAD_URL, UPLOAD_ADMIN_FILE_URL, UPLOAD_FILE_URL } from '@services/urls/files';
import * as CsrHttpService from '@http/csr-http.service';
import { hasWindow } from '@services/http.service';
import * as SsrHttpService from '@http/ssr-http.service';
import { GENAI_FILE_UPLOAD_URL } from './urls/genAi';
import { isValidResponseEntity } from '@helpers/utils';

export const fileUploadHandler = (bucket, file, key, contentType = null, ctx = null) => {
    const url = UPLOAD_FILE_URL();

    const formData = new FormData();
    formData.append('file', file);
    formData.append('fileName', key);
    formData.append('bucket', bucket);
    if (contentType) {
        formData.append('contentType', contentType);
    }
    if (hasWindow()) {
        return CsrHttpService.postWithAuthMultipart(url, formData);
    }
    return SsrHttpService.postWithAuthMultipart(url, formData, ctx);
};


export const getPresignedUploadUrl = (bucket, key, expiry, ctx) => {
    const url = GET_PRE_SIGNED_UPLOAD_URL(bucket, key, expiry);

    if (hasWindow()) {
        return CsrHttpService.getWithAuth(url);
    }
    return SsrHttpService.getWithAuth(url, ctx);
}

export const fileUploadHandlerV2 = async (
    bucket,
    file,
    key,
    contentType = null,
    expiry,
    ctx = null
) => {
    try {
        const preSignedUrlResponse = await getPresignedUploadUrl(bucket, key, expiry, ctx);

        if (!isValidResponseEntity(preSignedUrlResponse)) {
            return {
                status: 501,
                message: 'Invalid pre-signed URL response',
            };
        }

        const formData = new FormData();
        formData.append('file', file);

        const uploadUrl = preSignedUrlResponse?.entity;

        try {
            if (hasWindow()) {
                await CsrHttpService.putWithAuthMultipart(uploadUrl, formData);
            } else {
                await SsrHttpService.putWithAuthMultipart(uploadUrl, formData, ctx);
            }
            
            return {
                status: true,
                message: 'File uploaded successfully',
                entity: `https://${bucket}.s3.amazonaws.com/${key}`,
            };
        } catch (uploadError) {
            return {
                status: false,
                message: 'Failed to upload file to S3',
            };
        }
    } catch (error) {
        return {
            status: false,
            message: 'Unexpected server error during file upload',
        };
    }
};

export const adminFileUploadHandler = (bucket, file, key, ctx = null) => {
    const url = UPLOAD_ADMIN_FILE_URL();

    const formData = new FormData();
    formData.append('file', file);
    formData.append('fileName', key);
    formData.append('bucket', bucket);
    if (hasWindow()) {
        return CsrHttpService.postWithAuthMultipart(url, formData);
    }
    return SsrHttpService.postWithAuthMultipart(url, formData, ctx);
};

export const genAifileUploadHandler = ({ file, ...rest }, ctx = null) => {
    const url = GENAI_FILE_UPLOAD_URL();

    const formData = new FormData();
    formData.append('file', file);
    Object.entries(rest).forEach(([key, value]) => {
        formData.append(key, value);
    });

    if (hasWindow()) {
        return CsrHttpService.postWithAuthMultipart(url, formData);
    }
    return SsrHttpService.postWithAuthMultipart(url, formData, ctx);
};
